var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDodrewnaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.03 55.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.03,20.58c-2.43-5.4-3.72-11.3-3.72-17.07V0h-7.18v1.99c0,6.01,1.62,12.02,4.7,17.36,3.03,5.26,3.04,11.75,0,17.03-3.07,5.34-4.7,11.35-4.7,17.36v1.99h7.18v-3.62c0-5.77,1.25-11.48,3.72-16.96,2-4.45,2.03-10.06,0-14.58h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 26.01,
    cy: 27.86,
    rx: 1.85,
    ry: 5.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,35.15c2.47,5.48,3.72,11.18,3.72,16.96v3.62h7.18v-1.99c0-6.01-1.62-12.02-4.7-17.36-3.03-5.26-3.04-11.75,0-17.03,3.07-5.34,4.7-11.35,4.7-17.36V0h-7.18v3.51c0,5.76-1.28,11.67-3.72,17.07-2,4.45-2.03,10.06,0,14.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.45,52.11c0-5.31-1.15-10.56-3.43-15.62-2.39-5.32-2.41-11.9,0-17.26,2.24-4.98,3.43-10.42,3.43-15.73V0H1.63C.73,0,0,.73,0,1.63v52.46c0,.9.73,1.63,1.63,1.63h8.82v-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.4,0h-8.82v3.51c0,5.31,1.19,10.74,3.43,15.73,2.39,5.32,2.41,11.9,0,17.26-2.27,5.05-3.43,10.31-3.43,15.62v3.62h8.82c.9,0,1.63-.73,1.63-1.63V1.63C52.03.73,51.3,0,50.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.86,55.73v-1.99c0-6.58,1.77-13.15,5.13-18.99,2.45-4.26,2.46-9.5,0-13.77-3.36-5.84-5.13-12.4-5.13-18.99V0h-3.7v1.99c0,6.58-1.77,13.15-5.13,18.99-2.45,4.26-2.46,9.5,0,13.77,3.36,5.84,5.13,12.4,5.13,18.99v1.99h3.7ZM22.09,33.52c-1.59-3.18-1.59-8.13,0-11.31.95-1.9,2.34-2.94,3.92-2.94s2.97,1.05,3.92,2.94c1.59,3.18,1.59,8.13,0,11.31-.95,1.9-2.34,2.94-3.92,2.94s-2.97-1.05-3.92-2.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodrewnaIcon);
export default __webpack_public_path__ + "static/media/Do drewna_icon.8dd9aec24578fe89f0bcad39e8c607d3.svg";
export { ForwardRef as ReactComponent };